import { useMemo, useContext } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { useStyles } from "./TopFiveFailureCodesSlide.styles";
import { HMIContext } from "contexts/HMIContext/HMIContext";
import { BarsChartFailureCodes } from "components/BarsChartFailureCodes/BarsChartFailureCodes.view";
import { NoStatsDataSlide } from "../index";
import { GraphsNotEnoughDataInMinutes } from "components/GraphsNotEnoughDataInMinutes/GraphsNotEnoughDataInMinutes.view";
import { IEventWithHours } from "components/HMIUptimeDowntimeBar/HMIUptimeDowntimeBarInterfaces";
import { buildFailureCodesChartData } from "./failureCodesTransforms";

interface TopFiveFailureCodesSlideProps {
    downtimeEvents: IEventWithHours[] | undefined;
    countryCode?: string;
}

export const TopFiveFailureCodesSlide = ({ downtimeEvents, countryCode }: TopFiveFailureCodesSlideProps) => {
    const { t, i18n } = useTranslation();
    const classes = useStyles();
    const { displayUnit } = useContext(HMIContext);

    const { sortedData, isEmpty } = useMemo(
        () => buildFailureCodesChartData(downtimeEvents, displayUnit, i18n.language, countryCode),
        [downtimeEvents, displayUnit, i18n.language, countryCode],
    );

    return (
        <Box className={classes.slideRoot}>
            <Typography variant="h1" className={classes.title}>
                {t("HMI.top_five_failure_codes.title")}
            </Typography>
            {downtimeEvents && downtimeEvents.length > 0 ? (
                isEmpty ? (
                    <GraphsNotEnoughDataInMinutes />
                ) : (
                    <Box className={classes.graphContainer}>
                        {sortedData.map((failureTypeAndCodes) => {
                            if (
                                failureTypeAndCodes.failureCodes[0] &&
                                Object.values(failureTypeAndCodes.failureCodes[0]).some(
                                    (item: string | number | null) =>
                                        typeof item === "number" && !isNaN(item) && item > 0,
                                )
                            ) {
                                return (
                                    <Box
                                        key={failureTypeAndCodes.failureType}
                                        className={classes.graphGridItemContainer}
                                    >
                                        <Typography className={classes.graphTitle} variant="subtitle1">
                                            {failureTypeAndCodes.failureType}
                                        </Typography>
                                        <BarsChartFailureCodes data={failureTypeAndCodes.failureCodes} />
                                    </Box>
                                );
                            } else {
                                return null;
                            }
                        })}
                    </Box>
                )
            ) : (
                <NoStatsDataSlide />
            )}
        </Box>
    );
};
